import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {MatDialog} from '@angular/material/dialog';
import {OrderDetailComponent} from '../order-detail/order-detail.component';


@Component({
  selector: 'app-assigned-orders',
  templateUrl: './assigned-orders.component.html',
  styleUrls: ['./assigned-orders.component.css']
})
export class AssignedOrdersComponent implements OnInit {

  displayedColumns: string[] = ['codigo','tienda','estado','usuario','direccion','items','total','opciones'];
  dataSource = ELEMENT_DATA;

  constructor(
    public dialog: MatDialog,
    private router: Router
  ) { }

  open() {
    this.dialog.open(OrderDetailComponent);
  }
  
  printOrder(){
    this.router.navigate(['order-receipt']);
  }

  ngOnInit(): void { }

  
}
export interface AssignedOrders{
  codigo: string;
  tienda: string;
  estado: string;
  usuario: string;
  telefono: number;
  direccion: string;
  items: string;
  total: any;
  opciones: string;
  idCadete: string;
  nombreCadete: string;
  fechaPedido: string;

}
const ELEMENT_DATA: AssignedOrders[] = [
  { codigo: '#3446', tienda: 'Sushi King', estado: 'Cadete', usuario:'nombre',telefono: 2455442, direccion: 'San Salvador 1520', items: '',total: '', opciones: '', nombreCadete:'Calvin Hidalgo', idCadete: '#123', fechaPedido:'2020-09-10 00:50:18'},
  { codigo: '', tienda: 'Sushi King', estado: 'Cadete', usuario:'nombre',telefono: 2455442, direccion: 'Rosario 1520', items: '', total: '',opciones: '', nombreCadete:'Calvin Hidalgo', idCadete: '#123', fechaPedido:'2020-09-10 00:50:18' },
  
];


